<template>   
    <v-icon                  
      @click="download">
      mdi-file-excel
    </v-icon>
</template>

<script>
import XLSX from 'xlsx';
export default {
  name: 'Xlsx',
  components: {},
  props: {
    items: {},
    filename: String,
    headers: {}  
  },
  data: () => ({    
  }),
  watch: {    
  },
  computed: {},
  methods: {
    download : function() {
        this.items.unshift(this.headers);
        const data = XLSX.utils.json_to_sheet(this.items, {skipHeader: true})
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, this.filename)
        XLSX.writeFile(wb,this.filename+".xlsx")
      }
  }
}
</script>